import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import { Button } from '@material-ui/core';
import ACCESS from '../../../ACCESS.js';

class Circuitos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'circuito/filter', deleteUrl: 'circuito/delete', deleteField: 'circuito', modUrl: '/Catalogo/Circuito' },
      TableOp.Table('Circuitos', [
        { label: 'Circuito', id: 'circuito' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_CIRCUITOS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_CIRCUITOS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div style={{ padding: 10 }} >
          <Button variant='contained' color='primary' onClick={() => {this.props.history.push('/Catalogo/Circuito')}} >Agregar Circuito</Button>
        </div>
        <this.TableRender  />
      </div>
    )
  }
}

export default withRouter(Circuitos)